import { render, staticRenderFns } from "./EditBulkMenus.vue?vue&type=template&id=d417a582&lang=pug"
import script from "./EditBulkMenus.vue?vue&type=script&lang=js"
export * from "./EditBulkMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports